import React from 'react';
import PropTypes from 'prop-types';
import { BigBlueButton } from 'lib/styles';

const Save = props => <BigBlueButton onClick={ props.viewItems ? props.addItems : props.saveHandler }>{props.value}</BigBlueButton>

Save.propTypes = {
	value: PropTypes.string,
	viewItems: PropTypes.bool,
	saveHandler: PropTypes.func,
	addItems: PropTypes.func,
}

export default Save
